import { DEFAULT_COOKIES } from 'tradera/constants/cookies';
import type { SITE_LAYOUT } from 'tradera/constants/ui';
import { useMemberServerStorageWithCookieFallbackString } from 'tradera/state/member-storage/hooks';

export const useSiteLayout = () =>
    useMemberServerStorageWithCookieFallbackString<SITE_LAYOUT>(
        DEFAULT_COOKIES.SITE_LAYOUT.key,
        DEFAULT_COOKIES.SITE_LAYOUT.default as SITE_LAYOUT,
        DEFAULT_COOKIES.SITE_LAYOUT.length
    );
